import { Button, Column } from 'components/Blocks';
import { HomeIcon } from 'components/Icons';
import { NotFoundIllustration } from 'components/Illustrations';
import { useLang } from 'hooks/lang';

export default function NotFoundPage() {
  const { t } = useLang();

  return (
    <Column alignItems="center" justifyContent="center" fullHeight>
      <NotFoundIllustration className="h-52" />

      <h6 className="mt-2 text-primary">{t('page-not-found')}</h6>

      <p>{t('page-404-desc')}</p>

      <Button to="home">
        <HomeIcon />
        Home
      </Button>
    </Column>
  );
}
